module.exports = __webpack_public_path__ + "media/Images/about-figure-002-8c20d9822d609ac9e4e5fad172a8836d.svg";